module.exports = __webpack_public_path__ + "static/floatingDices-b9ce52921174d4aa5b1a2959a2b43cfb.png";